import React, {Component} from "react";

import transl from "./Transl";

export default class ApplicationForm extends Component{

    render(){

        let {
            className = ""
        } = this.props;

        return <div className={"ApplicationForm "+(className ? " "+className : "")}>
            <div className="ApplicationFormCapt" dangerouslySetInnerHTML={{__html: transl[process.env.REACT_APP_LANG].FormCapt }}/>

            {this.props.children}

        </div>
    }

}